import React from 'react';
import { Reveal } from '../Reveal';
import { transformacion } from '../../data/content';
export function Transformacion() {
  return <section aria-labelledby="transformacion-titulo" className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-299" data-mp="2o92vbwd1fa8a">
      <div className="mx-auto max-w-5xl" data-id="element-300" data-mp="29kg5v1tp523c">
        <Reveal data-id="element-301" data-mp="2ejauwli9bmvw">
          <h2 id="transformacion-titulo" className="text-center font-display text-3xl font-bold text-bordo sm:text-4xl" style={{
          fontSize: "26px",
          fontWeight: "800"
        }} data-id="element-302" data-mp="2eirdr70fl2ix">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </Reveal>

        {/* Tabla en escritorio */}
        <Reveal delay={0.05} data-id="element-303" data-mp="1qm3vjcr1tm66">
          <div className="mt-10 hidden overflow-hidden rounded-2xl border border-black/5 shadow-soft md:block" data-id="element-304" data-mp="1qn5gqa1s3p1m">
            <table className="w-full border-collapse text-left" data-id="element-305" data-mp="1vlgp0gcfdrhq">
              <caption className="sr-only" data-id="element-306" data-mp="3kzmwyxo79owr">
                Comparación entre trabajar sin Profes de Telas Resuelto y con Profes de Telas Resuelto
              </caption>
              <thead data-id="element-307" data-mp="3r1iyqemxl2gb">
                <tr data-id="element-308" data-mp="3r0zkb7whow71">
                  <th scope="col" className="w-1/2 bg-grisclaro px-6 py-4 text-xs font-bold uppercase tracking-wide text-tintasuave" data-id="element-309" data-mp="3r07xalgyk6sd">
                    Sin Profes de Telas Resuelto
                  </th>
                  <th scope="col" className="w-1/2 bg-verde/10 px-6 py-4 text-xs font-bold uppercase tracking-wide text-verde-dark" data-id="element-310" data-mp="4kmxprh96oqg">
                    Con Profes de Telas Resuelto
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-311" data-mp="333k27qmh8vy7">
                {transformacion.map(fila => <tr key={fila.sin} className="border-t border-black/5" data-id="element-312" data-mp="335ephbl8105g">
                    <td className="px-6 py-4 text-sm leading-relaxed text-tintasuave" data-id="element-313" data-mp="3h44iog4x6foj">{fila.sin}</td>
                    <td className="bg-verde/5 px-6 py-4 text-sm font-medium leading-relaxed text-tinta" data-id="element-314" data-mp="3d0yinq8ehkqi">
                      {fila.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>

        {/* Tarjetas apiladas en celular */}
        <div className="mt-10 grid gap-4 md:hidden" data-id="element-315" data-mp="3l5r2dzpwotj7">
          {transformacion.map((fila, index) => <Reveal key={fila.sin} delay={Math.min(index, 4) * 0.03} data-id="element-316" data-mp="3q76pryfk3c4r" data-mpi={index}>
              <div className="overflow-hidden rounded-2xl border border-black/5 shadow-soft" data-id="element-317" data-mp="3v5i0ebdodqo1">
                <div className="bg-grisclaro px-5 py-4" data-id="element-318" data-mp="2z32co9pqwke">
                  <p className="text-[10px] font-bold uppercase tracking-wide text-tintasuave" data-id="element-319" data-mp="32frkbwshgepa">
                    Sin Profes de Telas Resuelto
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-tintasuave" data-id="element-320" data-mp="37euicxa1pknr">{fila.sin}</p>
                </div>
                <div className="bg-verde/10 px-5 py-4" data-id="element-321" data-mp="3becxfcf6r1io">
                  <p className="text-[10px] font-bold uppercase tracking-wide text-verde-dark" data-id="element-322" data-mp="3g7podt7c7kel">
                    Con Profes de Telas Resuelto
                  </p>
                  <p className="mt-1.5 text-sm font-medium leading-relaxed text-tinta" data-id="element-323" data-mp="2nq3i8tch9c0i">{fila.con}</p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}